"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedView = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const styled_1 = require("../styled");
const styled_2 = require("./styled");
const index_1 = require("../../index");
const FailedView = ({ formName, setFormStateHandler }) => (react_1.default.createElement(styled_1.StateWrapper, { className: "failed-state-wrapper" },
    react_1.default.createElement(styled_1.ContentWrapper, { className: "content-wrapper" },
        react_1.default.createElement(styled_2.HeaderWrapper, { className: "header-wrapper" },
            react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.headline300, bold: true, textAlign: components_core_1.TextAlignment.center }, "Oops! Something went wrong!")),
        react_1.default.createElement(styled_2.FailedTextWrapper, { className: "text-wrapper" },
            react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.headline200, textAlign: components_core_1.TextAlignment.center }, "We couldn\u2019t receive your message at the moment. Please try again.")),
        react_1.default.createElement(index_1.Button, { appearance: index_1.ButtonAppearance.Primary, onClick: setFormStateHandler },
            "Back to ",
            formName))));
exports.FailedView = FailedView;
